export const sha256 = async (text: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(text)
  const hash = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

const generateUUID = () =>
  Date.now()
    .toString()
    .substr(Date.now().toString().length - 8)

export const generateRandomBytes = () => generateUUID()
